exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Styles used in SurveyInfo component */\n\n\n.show-grid {\n    text-align: center;\n}\n\n.survey-input {\n    margin-left: 25%;\n    margin-right: 25%;\n    background: \"#ffffff\";\n}\n.survey-input2 {\n    margin-left: 25%;\n}\n\n.selectinfo\n{\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: 0.8rem;\n    color: #000000 !important;\n}\n.padder\n{\n    padding-left: 15px;\n    padding-right: 15px;\n}", ""]);

// exports
